// extracted by mini-css-extract-plugin
module.exports = {"title":"FT3xScCo","warn":"m54xKrlq","sucess":"PU3AsgI7","content":"e_7QD505","footer":"RjuiKCnF"};